import { render, staticRenderFns } from "./ProfileEditItem.vue?vue&type=template&id=6e845881&"
import script from "./ProfileEditItem.vue?vue&type=script&lang=js&"
export * from "./ProfileEditItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports